export type ClientDuplicateLevel =
  | 'strong'
  | 'probable'
  | 'warning';

export type ClientDuplicateReason =
  | 'document'
  | 'phone'
  | 'email'
  | 'name';

export type ClientDuplicateCandidate = {
  id: string;
  name: string;
  personType: string;

  level:
    ClientDuplicateLevel;

  reasons:
    ClientDuplicateReason[];
};

const reasonLabels:
  Record<
    ClientDuplicateReason,
    string
  > = {
  document:
    'mesmo CPF/CNPJ',

  phone:
    'mesmo telefone',

  email:
    'mesmo e-mail',

  name:
    'mesmo nome',
};

export const getStrongDuplicate =
  (
    candidates:
      ClientDuplicateCandidate[]
  ) =>
    candidates.find(
      (
        candidate
      ) =>
        candidate.level ===
        'strong'
    ) ??
    null;

export const getProbableDuplicates =
  (
    candidates:
      ClientDuplicateCandidate[]
  ) =>
    candidates.filter(
      (
        candidate
      ) =>
        candidate.level ===
        'probable'
    );

export const getWarningDuplicates =
  (
    candidates:
      ClientDuplicateCandidate[]
  ) =>
    candidates.filter(
      (
        candidate
      ) =>
        candidate.level ===
        'warning'
    );

export const formatDuplicateReasons =
  (
    reasons:
      ClientDuplicateReason[]
  ) =>
    reasons
      .map(
        (
          reason
        ) =>
          reasonLabels[
            reason
          ]
      )
      .join(
        ', '
      );

export const formatClientDuplicateSummary =
  (
    candidates:
      ClientDuplicateCandidate[],
    limit = 3
  ) =>
    candidates
      .slice(
        0,
        limit
      )
      .map(
        (
          candidate
        ) =>
          `${candidate.name} — ${formatDuplicateReasons(
            candidate.reasons
          )}`
      )
      .join(
        '\n'
      );